import React, { useState, useEffect } from 'react';
import { CloseButton, Modal } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Numeric from '../../../../../../components/Numeric';

export default function Divider(props) {
  const { rest, divide, openDivider, setOpenDivider } = props;
  const [qty, setQty] = useState(0);
  const [err, setErr] = useState('');

  useEffect(() => {
    setQty(1);
  }, [rest]);

  const clickOk = () => {
    if (!err) {
      divide(qty);
      setOpenDivider(false);
    }
  };
  const back = () => {
    setOpenDivider(false);
  };
  const changeQty = (val) => {
    //console.log('newQty', val);
    if (val < 2) {
      setQty(1);
      setErr('');
      //console.log('qty', qty);
    } else if (val <= rest) {
      setQty(val);
      //console.log('qty', qty);
      setErr('');
    } else {
      setErr(`Хуваах барааны тоо хэтэрлээ. Ихдээ ${rest} байж болно!`);
    }
  };

  return (
    <>
      <Modal
        size='sm'
        show={openDivider}
        onHide={back}
        backdrop='static'
        keyboard={false}
        aria-labelledby='example-modal-sizes-title-sm'
      >
        <Modal.Header>
          <Modal.Title id='example-modal-sizes-title-sm'>
            Бараа хуваах
          </Modal.Title>
          <CloseButton onClick={back} />
        </Modal.Header>
        <Modal.Body>
          <Container>
            {' '}
            {err && (
              <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                <div className='alert-text font-weight-bold'>{err}</div>
              </div>
            )}
            <Numeric
              name={qty}
              value={qty}
              className='form-control form-control-sm'
              negative={false}
              type='number'
              decimalScale='0'
              fixedDecimalScale={false}
              defaultValue='0'
              onChange={changeQty}
            />
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' onClick={back} className='btn btn-light'>
            Болих
          </button>
          <> </>
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={clickOk}
          >
            Хадгалах
          </button>
        </Modal.Footer>
      </Modal>

      {/*  <CardHeader title='Бүтээгдэхүүн сонгох'>
    <CardHeaderToolbar>
      <button type='button' onClick={back} className='btn btn-light'>
        <i className='fa fa-arrow-left'></i>
        Болих
      </button>
      <> </>
      <button
        type='submit'
        className='btn btn-primary ml-2'
        onClick={clickOk}
      >
        Сонгох
      </button>
    </CardHeaderToolbar>
  </CardHeader>
  <CardBody>
    
  </CardBody> */}
    </>
  );
}
